var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.emptyOption
        ? _c(
            "div",
            [
              _c(
                "b-form-checkbox",
                {
                  attrs: { disabled: _vm.disabled },
                  on: { change: _vm.emptyChanged },
                  model: {
                    value: _vm.empty,
                    callback: function($$v) {
                      _vm.empty = $$v
                    },
                    expression: "empty"
                  }
                },
                [_vm._v("\n\t\t\t" + _vm._s(_vm.emptyOption.label) + "\n\t\t")]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("b-form-checkbox-group", {
        attrs: { options: _vm.options, disabled: _vm.disabled, stacked: "" },
        on: { change: _vm.selectedChanged },
        model: {
          value: _vm.selected,
          callback: function($$v) {
            _vm.selected = $$v
          },
          expression: "selected"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }